<script lang="ts" setup>
import { computed, inject, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import { HistoryType } from '.';
import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';
import { DetailsBuilderContract } from '@/components/builder/details';
import DocumentHistory from '@/views/partials/components/History.vue';
import properties from '../../properties';

defineOptions({
    name: 'HistoryBlueprint',
    components: {
        ...properties,
    },
});

const props = defineProps({
  "blueprint": null,
  "details": null,
  "parent": null
});

const route = useRoute();

const isAdmin = inject<Ref<boolean>>('isAdmin', ref(false));

const blueprint = computed(() => props.blueprint);
const licence = computed(() => route.params.licence as string);
const publicId = computed(() => route.params.publicId as string);
const design = computed(() => props.details.designMode());
</script>

<template>
    <dynamic-details-component-wrapper :details="details" :parent="parent" :blueprint="blueprint">
        <template #default>
            <document-history :blueprint-name="blueprint.name" :design="design" :public-id="publicId" :type="licence" :is-admin="isAdmin" />
        </template>
        <template #properties>
            <field-name v-model="blueprint.name" />
            <dynamic-details-accordion>
                <dynamic-details-accordion-item icon="far fa-table" :header="$t('[[[Prezentacja]]]')" :open="true">
                    <field-visible :details="details" :blueprint="blueprint" />
                </dynamic-details-accordion-item>
            </dynamic-details-accordion>
        </template>
    </dynamic-details-component-wrapper>
</template>
